import emojiData from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React from "react";
EmojiPicker.defaults = {
    previewPosition: "none",
};
function EmojiPicker({ data = emojiData, onEmojiSelect, previewPosition, theme, }) {
    return (React.createElement(Picker, { theme: theme, previewPosition: previewPosition, data: data, onEmojiSelect: onEmojiSelect }));
}
export { EmojiPicker, emojiData as DataEmojiMart };
//# sourceMappingURL=EmojiPicker.js.map